import UnassignedJourneyCard from './container';

export default UnassignedJourneyCard;
